<template>
  <div class="page-popularize">
    <div class="header">
      <div class="back" @click="$router.back()"></div>
      <h1>推广记录</h1>
    </div>
    <div class="table">
      <div class="head">
        <p>设备号</p>
        <p>下载时间</p>
      </div>
      <div class="body">
        <div class="row" v-for="record in records" :key="record.id">
          <p>{{ record.dev }}</p>
          <p>{{ record.date }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPopularizeRecord } from "@/api/vip";

export default {
  name: "PopularizeRecord",
  data() {
    return {
      records: []
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.records = await getPopularizeRecord();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-popularize {
  background-image: url("../../assets/vip/bg@2x.png");
  min-height: 100vh;
  background-position-y: -2px;
  overflow: hidden;
  .header {
    .back {
      position: absolute;
      left: 0;
      width: 40px;
      height: 40px;
      background-image: url("../../assets/vip/back_black@2x.png");
      background-size: 9px 14px;
      background-position: center;
      background-repeat: no-repeat;
    }
    h1 {
      font-size: 16px;
      font-weight: 500;
      color: rgba(33, 40, 50, 1);
      line-height: 40px;
    }
  }
  .table {
    margin: 25px 15px;
    background: rgba(255, 255, 255, 1);
    border-radius: 12px;
    border: 1px solid rgba(161, 77, 3, 1);
    p {
      width: 50%;
      text-align: left;
    }
    .head {
      padding: 0 20px;
      display: flex;
      border-bottom: 1px solid rgba(230, 230, 230, 1);
      p {
        font-size: 15px;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
        line-height: 50px;
      }
    }
    .body {
      padding: 10px 20px;
      .row {
        margin: 13px 0;
        display: flex;
        font-size: 12px;
      }
    }
  }
}
</style>
